import styled from 'styled-components';
import { sizes } from 'style';
import { colors } from 'style/theme';

export const Background = styled.div`
  position: relative;
  background-color: ${colors.portGore};

  @media ${sizes.desktop} {
    background-color: transparent;
    min-height: 640px;
  }
`;

export const ImageContainer = styled.div`
  margin-top: -246px;

  /* submarine birb */
  & img:nth-child(3) {
    margin-top: 124px;
    width: 70%;
    right: 0;
    left: auto;
  }
  /* diver birb */
  & img:nth-child(4) {
    margin-top: 124px;
    width: 70%;
  }

  @media ${sizes.tabletPortrait} {
    margin-top: -128px;
    & img:nth-child(3),
    & img:nth-child(4) {
      width: 100%;
      right: auto;
      margin-top: 0;
    }
  }

  @media ${sizes.desktop} {
    margin-top: 0;
    position: absolute;
    top: -64px;
    left: 0;
    right: 0;
    bottom: 0;
  }

  @media ${sizes.largeDesktop} {
    top: -128px;
  }
`;
